if (!customElements.get('legal-page-content')) {
  class LegalPageContent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.segmented) return;
      this.dataset.segmented = 'true';

      const rte = this.querySelector('[data-legal-page-rte]');
      if (!rte) return;

      const level = (this.dataset.headingLevel || 'h2').toLowerCase();
      const children = [...rte.childNodes];
      const headingIndexes = children.reduce((indexes, node, index) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === level) {
          indexes.push(index);
        }
        return indexes;
      }, []);

      if (headingIndexes.length === 0) return;

      const iconTemplate = this.querySelector('[data-legal-accordion-icon]');
      const fragment = document.createDocumentFragment();
      const introNodes = children.slice(0, headingIndexes[0]);
      const hasIntro = introNodes.some(
        (node) => node.nodeType === Node.ELEMENT_NODE || node.textContent.trim() !== ''
      );

      if (hasIntro) {
        const intro = document.createElement('div');
        intro.className = 'rte legal-page-content__intro';
        introNodes.forEach((node) => intro.appendChild(node));
        fragment.appendChild(intro);
      }

      const group = document.createElement('div');
      group.className = 'legal-accordion-group';

      headingIndexes.forEach((startIndex, position) => {
        const endIndex = headingIndexes[position + 1] ?? children.length;
        const heading = children[startIndex];
        const bodyNodes = children.slice(startIndex + 1, endIndex);
        group.appendChild(this.buildAccordion(heading, bodyNodes, iconTemplate, position));
      });

      fragment.appendChild(group);
      rte.replaceWith(fragment);
    }

    buildAccordion(heading, bodyNodes, iconTemplate, position) {
      const contentId = `${this.id || 'LegalPageContent'}-accordion-${position}`;
      const label = document.createElement('span');
      label.className = 'accordion-toggle__label';
      label.textContent = heading.textContent.trim();

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'accordion-toggle__trigger';
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', contentId);
      trigger.setAttribute('data-accordion-trigger', '');
      trigger.appendChild(label);

      if (iconTemplate) {
        trigger.appendChild(iconTemplate.content.cloneNode(true));
      }

      heading.textContent = '';
      heading.classList.add('legal-accordion__heading');
      heading.appendChild(trigger);

      const contentInner = document.createElement('div');
      contentInner.className = 'accordion-toggle__content-inner rte';
      bodyNodes.forEach((node) => contentInner.appendChild(node));

      const content = document.createElement('div');
      content.id = contentId;
      content.className = 'accordion-toggle__content';
      content.setAttribute('data-accordion-content', '');
      content.setAttribute('data-expanded', 'true');
      content.appendChild(contentInner);

      const accordion = document.createElement('theme-accordion');
      accordion.className = 'legal-accordion accordion-toggle';
      accordion.setAttribute('data-expanded', '');
      accordion.append(heading, content);

      return accordion;
    }
  }

  customElements.define('legal-page-content', LegalPageContent);
}
